import axios from 'axios';

import { config } from '../config';

export const getIsEmailInUse = (email: string) => {
    return axios.post(config.endpoints.checkEmail, { email });
};
